// extracted by mini-css-extract-plugin
module.exports = {"image":"RandomHomePageImage_image__0ZakZ"};